<template>

  <v-hover v-slot:default="{ hover }">
    <v-card :class="{'ma-1': true, 'hover': hover}" outlined @click="$emit('edit')">
      <v-list two-line style="background-color: transparent">
        <v-list-item>
          <v-list-item-avatar>
            <v-img v-if="user.avatar" :src="user.avatar"/>
            <v-icon v-else x-large v-html="`mdi-account-circle`"/>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-html="user.full_name"/>
            <v-list-item-subtitle v-html="user.email"/>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-hover>

</template>

<script>
  export default {
    props: {
      user: Object
    }
  }
</script>

<style scoped>

  .hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.025);
  }

</style>